import React from 'react';

export function StepIdentificatorsLabel() {
  return <>Klasifikace, Identifikátory</>;
}
